import {AxiosInstance} from "axios";
import AssetCategory from "../model/asset/AssetCategory";
import DictionaryItem from "../model/dictionary/DictionaryItem";

export default class AssetCategoryApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 *Fetch asset categories
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	fetchAssetCategories() {
		const url = `/api/web/asset_categories`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(AssetCategory.fromJson));
	}

	/**
	 * Create asset category action.
	 */
	createAssetCategory(data: AssetCategory): Promise<AssetCategory> {
		const url = `/api/web/asset_categories`;
		return this.axiosInstance.post(url, data.toJson()).then(resp => AssetCategory.fromJson(resp.data));
	}

	/**
	 * Update asset category action.
	 */
	updateAssetCategory(acId: string, data: AssetCategory): Promise<any> {
		const url = `/api/web/asset_categories/${acId}`;
		return this.axiosInstance.put(url, data.toJson());
	}

	/**
	 * Update asset category sort order.
	 * @param {DictionaryItem[]} assetCategories
	 * @returns {Promise<any>}
	 */
	updateSortOrder(assetCategories: AssetCategory[]) {
		const url = `/api/web/asset_categories/order`;
		const assetCategoryIds = assetCategories.map(ac => ac.id);
		return this.axiosInstance.put(url, assetCategoryIds);
	}
}